import React, { useState, useEffect } from "react";
import { TailSpin } from "react-loader-spinner";
import AssignedSystems from "./AssignedSystems";
import AssignedSystemLogs from "./AssignedSystemLogs";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { getApi } from "../../../utils/api";
import { API_GET_EMPLOYEES_WITH_ASSIGNED_ASSETS } from "../../../config/Endpoints";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useBreadcrumbs } from "../../../v2/context/breadcrumb/breadcrumb-context.tsx";
const AssetMonitoringSystemTabs = () => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const { setBreadcrumbs } = useBreadcrumbs();
  const location = useLocation();
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
  const [loadingEmployees, setLoadingEmployees] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const accessToken = Cookies.get("accessToken");

  const tabs = [
    { label: "System Activity Logs", component: AssignedSystemLogs },
    { label: "Assigned Systems", component: AssignedSystems },
  ];

  useEffect(() => {
    setBreadcrumbs([
      { label: "System Activity Report", path: "/dashboard/systemActivityReport" },
      { label: tabs[activeTabIndex].label },
    ]);
  }, [activeTabIndex]);

  useEffect(() => {
    const fetchEmployees = async () => {
      setLoadingEmployees(true);
      try {
        const res = await getApi(
          API_GET_EMPLOYEES_WITH_ASSIGNED_ASSETS,
          accessToken,
        );
        const employeeData = res?.data;
        const empOptions = employeeData.map((emp) => ({
          value: emp.userId,
          label: emp.fullName,
        }));

        setEmployees(empOptions);
      } catch (error) {
        setEmployees([]);
      } finally {
        setLoadingEmployees(false);
      }
    };

    fetchEmployees();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");

    if (tab === "systems") {
      setActiveTabIndex(1);
    } else {
      setActiveTabIndex(0);
    }
  }, [location]);

  return (
    <div className="wrapper-body">
      {loadingEmployees && (
        <div className="overlay">
          <div className="mt-5">
            <TailSpin
              height="100"
              width="100"
              radius="1"
              color="blue"
              ariaLabel="tail-spin-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          </div>
        </div>
      )}


      <div className="card rounded-lg">
        <div className="d-flex justify-content-between align-items-center ">
          <ul className="nav nav-tabs" role="tablist">
            {tabs.map((item, index) => (
              <li className="nav-item" role="presentation" key={index}>
                <button
                  className={`nav-link ${activeTabIndex === index ? "active" : ""}`}
                  type="button"
                  role="tab"
                  aria-selected={activeTabIndex === index}
                  onClick={() => {
                    setSelectedEmployee(null);

                    if (index === 0) {
                      navigate("/dashboard/systemActivityReport?tab=logs");
                    } else {
                      navigate("/dashboard/systemActivityReport?tab=systems");
                    }
                  }}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="tab-content mt-3 px-3">
          {tabs.map((item, index) => {
            const Component = item.component;
            return (
              activeTabIndex === index && (
                <div
                  key={index}
                  className="tab-pane fade show active"
                  role="tabpanel"
                >
                  <Component
                    employees={employees}
                    loadingEmployees={loadingEmployees}
                    selectedEmployee={selectedEmployee}
                    setSelectedEmployee={setSelectedEmployee}
                  />
                </div>
              )
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AssetMonitoringSystemTabs;
